var map = {
	"./CDP.png": "8c3f",
	"./FTSE.png": "4ef3",
	"./GRI-logo.png": "df05",
	"./Iraq-img.png": "1fd5",
	"./MSCI.png": "30ff",
	"./QRcode.png": "2030",
	"./SASB.png": "6bd2",
	"./SDG-goals.png": "065b",
	"./TCFD.png": "753d",
	"./United-Nation.png": "03d5",
	"./baharain-img.png": "27e5",
	"./bg1.png": "df80",
	"./bg2.png": "d5bb",
	"./bg4.png": "8f48",
	"./book.png": "0c96",
	"./generationyouth-banner.jpg": "8b1e",
	"./generationyouth-banner2.jpg": "2802",
	"./globe.png": "c93d",
	"./inclusivity.jpg": "2885",
	"./jordan.png": "380f",
	"./kuwait.png": "3b67",
	"./saudia-arabia.png": "367c",
	"./south-sudan.png": "68cb",
	"./sudan.png": "5f93",
	"./svg/Vision.svg": "f5b4",
	"./svg/bahrain.svg": "d717",
	"./svg/business.svg": "ad86",
	"./svg/climate.svg": "77c8",
	"./svg/customer.svg": "6784",
	"./svg/generaion.svg": "1748",
	"./svg/graduate.svg": "0a9b",
	"./svg/inclusivity.svg": "d381",
	"./svg/iraq.svg": "75ce",
	"./svg/jordan.svg": "84b5",
	"./svg/key.svg": "2f35",
	"./svg/kuwait.svg": "68d7",
	"./svg/mission.svg": "0994",
	"./svg/ngo.svg": "d69d",
	"./svg/online-learning.svg": "09f3",
	"./svg/saudi-arabia.svg": "ca26",
	"./svg/social-chart.svg": "4f18",
	"./svg/social-chart_ar.svg": "b4e4",
	"./svg/socialmedia.svg": "ecd3",
	"./svg/south-sudan.svg": "b8c1",
	"./svg/sudan.svg": "4432",
	"./svg/unicef.svg": "d235"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2619";